import { render, staticRenderFns } from "./GotLogDialog.vue?vue&type=template&id=0dd8af92&scoped=true&"
import script from "./GotLogDialog.vue?vue&type=script&lang=js&"
export * from "./GotLogDialog.vue?vue&type=script&lang=js&"
import style0 from "./GotLogDialog.vue?vue&type=style&index=0&id=0dd8af92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd8af92",
  null
  
)

export default component.exports